<template>
  <div class="form-floating">
    <textarea class="form-control edited-message" placeholder="Leave a comment here" id="floatingTextarea"
    :value="localCompany.title" @input="onTitleInput"></textarea>
    <label for="floatingTextarea">Título</label>
  </div>
  <br>
  <div class="form-floating">
    <textarea class="form-control edited-message" placeholder="Leave a comment here" id="floatingTextarea"
    :value="localCompany.message" @input="onMessageInput"></textarea>
    <label for="floatingTextarea">Mensagem</label>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  emits: ['update:company'],
  computed: {
    localCompany() {
      return { ...this.company };
    }
  },
  methods: {
    onTitleInput(e) {
      const updated = { ...this.company, title: e.target.value };
      this.$emit('update:company', updated);
    },
    onMessageInput(e) {
      const updated = { ...this.company, message: e.target.value };
      this.$emit('update:company', updated);
    }
  }
};
</script>

<style scoped>
.edited-message {
  height: 75px !important;
  overflow: auto;
}
</style>
